import React from 'react';
import '../assets/css/recommendation_cards_animation.css';

const RecommendationCardsAnimation = () => {
  const basename = process.env.PUBLIC_URL || '';

  const nodes = [
    { id: 'data-foundation', label: 'Vision & Value​', image: 'vision', angle: -90 },
    { id: 'ai-enablement', label: 'Adoption', image: 'adoption', angle: -54 },
    { id: 'analytics-1', label: 'Governance', image: 'governance', angle: -18 },
    { id: 'governance', label: 'Analytics', image: 'analytics', angle: 18 },
    { id: 'automation', label: 'Knowledge', image: 'knowledge', angle: 54 },
    { id: 'innovation', label: 'Architecture', image: 'architecture', angle: 90 },
    { id: 'insights', label: 'Innovation', image: 'innovation', angle: 126 },
    { id: 'optimization', label: 'Agents', image: 'agents', angle: 162 },
    { id: 'strategy', label: 'Platform', image: 'platform', angle: -162 },
    { id: 'governance-advanced', label: 'Product', image: 'product', angle: -126 }
  ];

  const RADIUS_PERCENT = 41;

  const getImagePath = (imageName) => {
    return `${basename}/images/${imageName}.webp`;
  };

  return (
    <div className="recommendation-cards-container">
      <div className="recommendation-diagram">
        {/* Rotating semicircle lines outside the main circle */}
        <svg className="rotating-lines-1" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
          {/* First rotating line - coral/red - tapered tail */}
          <path
            d="M 50,2 A 48,48 0 0,1 91.6,74.0 L 91.5,73.9 A 48,48 0 0,0 50,2 Z"
            fill="rgb(253, 96, 97)"
            stroke="none"
          />
        </svg>
        <div className="rotating-lines-1">
          <div className="rotating-line-head" style={{ backgroundColor: 'rgb(253, 96, 97)', left: '91.6%', top: '74.0%' }}></div>
        </div>
        
        <svg className="rotating-lines-2" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
          {/* Second rotating line - blue - tapered tail */}
          <path
            d="M 50,2 A 48,48 0 0,1 91.6,74.0 L 91.5,73.9 A 48,48 0 0,0 50,2 Z"
            fill="rgb(91, 155, 213)"
            stroke="none"
          />
        </svg>
        <div className="rotating-lines-2">
          <div className="rotating-line-head" style={{ backgroundColor: 'rgb(91, 155, 213)', left: '91.6%', top: '74.0%' }}></div>
        </div>
        
        <div className="diagram-ring subtle"></div>
        
        {/* Central text */}
        <div className="central-text">
          <h2 className="central-title">The Intelligent</h2>
          <h2 className="central-title">Enterprise Framework</h2>
        </div>
        {nodes.map((node) => {
          const angleInRadians = (Math.PI / 180) * node.angle;
          const top = 50 + RADIUS_PERCENT * Math.sin(angleInRadians);
          const left = 50 + RADIUS_PERCENT * Math.cos(angleInRadians);

          return (
            <div
              key={node.id}
              className="diagram-node"
              style={{
                top: `${top}%`,
                left: `${left}%`
              }}
            >
              <div className="node-icon-wrapper1">
                <img 
                  src={getImagePath(node.image)} 
                  alt={node.label}
                  className="node-icon"
                />
              </div>
              <span className="node-label">{node.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecommendationCardsAnimation;

